<template>
  <v-simple-table class="table-no-hover" dense>
    <template #default>
      <template v-for="(block, blockIndex) in visibleBlocks">
        <tbody :key="`block-${blockIndex}`">
          <tr v-if="block.provider">
            <th :colspan="labelColspan + 1">
              {{ providerName(block.provider) }}
            </th>
          </tr>

          <tr v-for="fund in block.funds" :key="fund.id">
            <td>{{ fund.name }}</td>
            <slot name="fund" :fund="fund" />
            <td>{{ $t(`bookings.fund.type.${fund.type}`) }}</td>
            <td>{{ formatCurrency(fund.price) }}</td>
          </tr>

          <tr>
            <td :colspan="labelColspan">{{ $t("bookings.priceTable.netTotal") }}</td>
            <td>{{ formatCurrency(block.netTotal) }}</td>
          </tr>

          <template v-if="block.tax">
            <tr>
              <td :colspan="labelColspan">{{ $t("bookings.priceTable.tax", { tax: block.tax }) }}</td>
              <td>+ {{ formatCurrency(block.taxTotal) }}</td>
            </tr>
            <tr>
              <td :colspan="labelColspan">
                {{ $t("bookings.priceTable.grossTotal", { provider: providerName(block.provider) }) }}
              </td>
              <td>
                <strong>{{ formatCurrency(block.grossTotal) }}</strong>
              </td>
            </tr>
          </template>
        </tbody>
      </template>

      <tfoot v-if="hasProviders">
        <tr>
          <td :colspan="labelColspan">{{ $t("bookings.priceTable.total.netTotal") }}</td>
          <td>{{ formatCurrency(totals.netTotal) }}</td>
        </tr>
        <tr>
          <td :colspan="labelColspan">{{ $t("bookings.priceTable.total.taxTotal") }}</td>
          <td>{{ formatCurrency(totals.taxTotal) }}</td>
        </tr>
        <tr>
          <td :colspan="labelColspan">
            <strong>{{ $t("bookings.priceTable.total.grossTotal") }}</strong>
          </td>
          <td>
            <strong>{{ formatCurrency(totals.grossTotal) }}</strong>
          </td>
        </tr>
      </tfoot>
    </template>
  </v-simple-table>
</template>

<script>
import bookingProviders from "@fng/common/bookingProviders";
import calculateBookingTotals from "@fng/common/calculateBookingTotals";

export default {
  props: {
    booking: {
      type: Object,
      required: true,
    },
    // number of columns in front of the price column (name, type and additional slot columns)
    labelColspan: {
      type: Number,
      default: 2,
    },
  },

  computed: {
    totals() {
      return calculateBookingTotals(this.booking);
    },

    hasProviders() {
      return this.totals.blocks.some((block) => block.provider);
    },

    visibleBlocks() {
      return this.totals.blocks.filter((block) => !block.provider || block.netTotal > 0);
    },
  },

  methods: {
    providerName(key) {
      return bookingProviders.find((provider) => provider.key === key)?.name || "";
    },

    formatCurrency: new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format,
  },
};
</script>
